var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowRange
    ? _c(
        "span",
        {
          staticClass: "floorplan-range",
          style: { transform: _vm.floorplanPosition },
        },
        [
          _c("span", {
            staticClass: "floorplan-range-inner",
            style: { transform: _vm.floorplanRotation },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }